import type { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
import { classes, pickLayoutClass } from './utils';

export type TileGridProps = {
  children: ReactNode[];
};

export default function TileGrid({ children }: TileGridProps) {
  return (
    <div className={twMerge(classes.grid, pickLayoutClass(children.length))}>
      {children}
    </div>
  );
}
